<template>
	<div class="createorder" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-card class="box-card" shadow="never">
			<el-row v-if="isdetail==1">
				<el-col :span="24">
					<div class="inputBox">
							<el-form size="mini" label-width="100px" :inline="true">
								<el-form-item label="单据编号 :">
									<span>{{orderinfo.billid}}</span>
								</el-form-item>
								<el-form-item label="所在仓库 :">
									<span>{{orderinfo.storehouse}}</span>
								</el-form-item>
								<el-form-item label="所在货架 :">
									<span>{{orderinfo.shelves}}</span>
								</el-form-item>
							</el-form>
						</div>
				</el-col>
			</el-row>
			<div class="inputBox" v-if="isdetail==0">
				<el-form size="mini" label-width="100px" :inline="true">
					<el-form-item label="单据编号" >
						<div>
							<el-input
								ref="billid"
								style="width:200px"
								type="text"
								v-model="orderinfo.billid"
								:disabled="isedit"
								@keyup.native="val => enterinput(val,{colnext:'storehouse',colperv:''})"
								:class="['inputItem','col8']"
							></el-input><i v-if="!iseditbill"
							  class="el-icon-edit el-input__icon"
							  @click="editinput('billid')"
							  style="cursor:pointer;"> 
							</i>
						</div>
					</el-form-item>
					<el-form-item label="所在仓库">
						<el-select
							ref="storehouse"
							v-model="orderinfo.storehouse"
							filterable
							style="width:200px"
							@keyup.native="val => enterinput(val,{colnext:'shelves',colperv:'billid'})"
							:class="['inputItem','col8']"
						>
							<el-option v-for="(opt, opti) in storehouselist" :key="opti" :value="opt.d_name">{{ opt.d_name }}</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="所在货架">
						<el-select
							ref="shelves"
							v-model="orderinfo.shelves"
							:class="['inputItem','col8']"
							filterable
							remote
							reserve-keyword
							placeholder="可输入货架号搜索"
							:remote-method="val => remoteMethod(val,'shelves')"
							:loading="shelvesloading"
							style="width:200px"
							@keyup.native="val => enterinput(val,{colnext:'',colperv:'storehouse'})" 
						>
							<el-option v-for="(opt, opti) in shelveslist" :key="opti" :value="opt.d_name">{{ opt.d_name }}</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="mini" @click="searchcargo">开始盘点</el-button>
					</el-form-item>
				</el-form>
			</div>
			<el-row>
				<packagecargo ref="packagecargo" :gridheight="gridheight" title="商品明细" :l_mode="'商品明细列表-'+t_type" :isselcargo="isselcargo" @loadcallback="loadcallback"></packagecargo>
			</el-row>
		</el-card>
		<el-row v-if="!btnhidden&&isdetail==0" class="footerhandler">
			<el-col :span="5" style="text-align: right;">
				<span style="color:transparent">1</span>
			</el-col>
			<el-col :span="3" class="submitBtn_cancel"><div @click="printstocktaking">打印</div></el-col>
			<el-col :span="3" class="submitBtn_warning"><div @click="saveorder(0)">保存</div></el-col>
			<el-col :span="3" class="submitBtn"><div @click="saveorder(1)">盘点完成</div></el-col>
		</el-row>
		<el-dialog :visible.sync="showsuccesswin" title="操作提示" width="650px" :close-on-click-modal="false" lock-scroll :show-close="false" :append-to-body="true">
			<el-row style="padding-bottom:20px;margin-top:-20px">
				<el-col style="text-align:center">
					<i class="el-icon-success" style="color:#80CBC4;font-size:55pt;"></i>
					<br />
					<br />
					<span style="font-size:20pt;font-weight: bold">{{tipsmsg}}</span>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8"><span style="color:transparent">1</span></el-col>
				<el-col :span="3"><el-button type="primary" size="medium" @click="successfun(1)">继续盘点</el-button></el-col>
				<el-col :span="4" style="text-align: right;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
		</el-dialog>
		<printhandler ref="printhandler"></printhandler>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import packagecargo from '@/components/order/import_package_cargo1.vue';
import printhandler from '@/components/order/printhandler.vue';
export default {
	components: {
		packagecargo,
		printhandler
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return{
			orderinfo:{
				billid:'',
				storehouse:'',
				shelves:''
			},
			windowHeight: window.innerHeight - 100,
			isselcargo:false,
			storehouselist:[],
			shelveslist:[],
			loading:false,
			isedit:true,
			btnhidden:false,
			isdetail:0,
			gridheight:'350px',
			t_type:'盘点',
			divclass:'createorder',
			isadd:false,
			tipsmsg:'盘点成功',
			showsuccesswin:false,
			iseditbill:false,
			editcargolist:[],
			shelvesloading:false,
			issaveed:false,
			sys:'盘点'
		};
	},
	mounted() {
		if (this.urlparam != undefined) {
			if(this.urlparam.billid!=undefined)
				this.orderinfo.billid=this.urlparam.billid;
			if(this.urlparam.isdetail!=undefined)
				this.isdetail=this.urlparam.isdetail;
			if(this.urlparam.isadd!=undefined)
			{
				if(this.urlparam.isadd=='1')
					this.isadd=true;
				else
					this.isadd=false;
			}
		}
		var that=this;
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/packagemanager/createorder.scss');
			that.init();
		});
	},
	methods:{
		init(){
			if(this.orderinfo.billid!=''){
				this.issaveed=true;
				this.GetStocktaking();
			}else{
				this.orderinfo.billid=new Date().getTime();
				this.GetStorage();
				//this.GetShelves();
				this.$refs.packagecargo.init({ syscol: this.syscol, orderinfo: this.orderinfo, iscopy: 0,t_type:this.t_type,isdetail:this.isdetail,isadd:this.isadd });
			}
		},
		GetStocktaking(){
			var that=this;
			this.$apipost.get.GetStocktaking({billid:this.orderinfo.billid}).then(res => {
				if (res != '') {
					if(res.state=='1'){
						that.iseditbill=true;
						that.orderinfo=res.info;
						that.editcargolist=res.cargolist;
						if(that.isdetail==0){
							that.GetStorage();
						}
						this.$nextTick(function() {
							that.$refs.packagecargo.init({ syscol: that.syscol, orderinfo:{list:[{cargolist:JSON.parse(JSON.stringify(res.cargolist))}]}, iscopy: 0,t_type:that.t_type,isdetail:that.isdetail,isadd:that.isadd});
						});
					}
				}
			}).catch(e=>{
				that.GetStocktaking();
			});
		},
		enterinput(event, i) {
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (i.colnext != '') {
						if (i.colnext == 'tablegrid'){
							if(this.$refs.cargo!=undefined)
								this.$refs.cargo[0].setgridfoucs();
						}
					}
				} else if (event.keyCode == 37) {
					if (i.colperv != '') this.$refs[i.colperv][0].focus();
				}
			}
		},
		editinput(){
			this.isedit=false;
			var that=this;
			this.$nextTick(function() {
				that.$refs.billid.focus();
			});
		},
		async GetStorage() {
			var that = this;
			this.$apipost.get.dic({ type: '仓库' }).then(res => {
				//debugger
				if (res != '') {
					that.storehouselist = res.list;
				}
			}).catch(e=>{
				that.GetStorage();
			});
		},
		GetShelves(value) {
			var that = this;
			this.$apipost.get.dic({ type: '货架',value:value }).then(res => {
				if (res != '') {
					that.shelveslist = res.list;
				}
			}).catch(e=>{
				that.GetShelves(value);
			});
		},
		loadcallback(){
			if(this.iseditbill&&this.isdetail==0)
				this.searchcargo(1);
		},
		searchcargo(type){
			var that = this;
			if(type==undefined)
				type=0;
			var paraminfo={
				storehouse:this.orderinfo.storehouse,
				shelves:this.orderinfo.shelves,
				userid:localStorage.getItem('userid')
			}
			this.$tool.loading('正在查询', this.divclass);
			this.$apipost.get.GetStocktakingCargo({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				that.clearcargolist();
				if (res != '') {
					if(res.state=='1'){
						if(type==1){
							res.list.forEach(e=>{
								//debugger
								that.editcargolist.forEach(f=>{
									if(e.id=f.id&&e.section==f.section){
										e.num=f.num;
										return false;
									}
								});
							});
						}
						this.$nextTick(function() {
							that.$refs.packagecargo.addcargorow(res.list);
						});
					}else
						this.$tool.message(res.message, 0);
				}
			}).catch(e=>{
				that.searchcargo();
			});
		},
		getorderObj(type) {
			var that = this;
			var error = '';
			var info={orderinfo:this.orderinfo,cargolist:[]};
			var pageset = this.$refs.packagecargo._data.pageset;
			var cargorow = this.$refs.packagecargo._data.columns;
			var index = 0;
			var cargolist = [];
			pageset.forEach(e => {
				index++;
				cargolist = [];
				e.setlist.forEach(b => {
				 if (b.controltype == 'table') {
						if (b.isnull == 'False') {
							if (b.cargolist.length > 0) {
								var cargoindex = 0;
								b.cargolist.forEach(cargo => {
									cargoindex++;
									for (var col in cargo) {
										cargorow.forEach(c => {
											if (col == c.field) {
												if (c.isnull == 'False' && c.colshow == '1') {
													if (cargo[col] == '') error = '【第' + cargoindex + '行】' + c.title + '为空';
												}
												return false;
											}
											if (error != '') return false;
										});
										if (error != '') return false;
									}
									if (error != '') return false;
								});
							} else error = '请填写' + b.showname;
						}
						if (error == '') cargolist = b.cargolist;
					}
				});
				if (error != '') {
					cargolist = [];
					return false;
				}
			});
			info.cargolist=cargolist;
			if(cargolist.length==0){
				this.$tool.message('无盘点商品',"0");
				info='';
				return false;
			}
			if(this.orderinfo.billid.toString().replace(/ /g,'')=='')
			{
				this.$tool.message('请填写单据编号',"0");
				info='';
				return false;
			}
			if(type==1){
				if(this.orderinfo.storehouse.replace(/ /g,'')==''){
					this.$tool.message('请选择所在仓库',"0");
					info='';
					return false;
				}
				if(this.orderinfo.shelves.replace(/ /g,'')==''){
					this.$tool.message('请选择货架',"0");
					info='';
					return false;
				}
			}
			return info;
		},
		//打印待盘点记录表
		printstocktaking(){
			if(this.issaveed){
				var that=this;
				this.$tool.loading('正在打印',this.divclass);
				if (that.$refs.printhandler != undefined) {
					that.$refs.printhandler.init({
						pageparam: this._data,
						isgrid: false,
						pkval: this.orderinfo.billid,
						searchinfo: '',
						funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
						handtype: 13, //1--取单号 2--取快递单并打印 3-取快递单并预览
						isrollback: false,
						parentpage: this,
						isprint: 1,
						batch: '',
						sys:this.sys
					});
				}
			}
			else
				this.saveorder(2);
		},
		//1-保存盘点信息并生成盘盈盘亏单据
		//0-仅保存盘点信息
		//2-保存盘点信息并打印
		saveorder(type){
			var info=this.getorderObj(type);
			if(info!='')
			{
				var that = this;
				info.p_bagid=info.orderinfo.storehouse;
				info.p_pkval=info.orderinfo.billid;
				if(this.iseditbill)
					info.editid=info.orderinfo.billid;
				info.t_id="stock_taking";
				info.p_mode="";
				info.sendaddress=type;
				info.u_userid=localStorage.getItem('userid');
				this.$tool.loading('正在保存', this.divclass);
				this.$apipost.post.SaveInfo({ paraminfo:info }).then(res => {
					if (res != '') {
						if(res.state=='1'){
							that.issaveed=true;
							that.iseditbill=true;
							if(type=='0')
							{
								this.$tool.loadingclose();
								that.showsuccesswin=true;
							}	
							else if(type=='1')
								that.savetaking();
							else if(type=='2')
								that.printstocktaking();
						}
						else
						{
							this.$tool.loadingclose();
							this.$tool.message(res.message, 0);
							if(res.localfilename!=undefined){
								if(res.localfilename!=""){
									this.$tool.downfile(that,res.localfilename);
								}
							}
						}
							
					}
				}).catch(e=>{
					that.saveorder(type);
				});
			}
		},
		//生成盘盈盘亏单据
		savetaking(){
			var that = this;
			var paraminfo=that.getorderObj();
			if(paraminfo!=''){
				//先 生成盘盈单
				that.savein(paraminfo);
			}
		},
		//盘盈入库
		savein(paraminfo){
			var that=this;
			var info=JSON.parse(JSON.stringify(paraminfo));
			var cargolist=JSON.parse(JSON.stringify(info.cargolist));
			
			var list=cargolist.filter(function(e){
				return parseInt(e.num)>parseInt(e.num2);//盘点数量大于账面数量
			});
			if(list.length>0){
				list.forEach(e=>{
					e.num=parseInt(e.num)-parseInt(e.num2);
				});
				info.p_pkval=new Date().getTime();
				info.p_bagid=info.orderinfo.storehouse;
				info.t_id="stock_in";
				info.p_sys="盘盈入库";
				info.p_mode="instock";
				info.sendtype='';
				info.sendaddress='';
				info.cargolist=list;
				info.u_userid=localStorage.getItem('userid');
				//再生成盘亏单
				this.$apipost.post.SaveInfo({ paraminfo:info }).then(res => {
					if (res != '') {
						if(res.state=='1')
							//更新库存
							that.UpdateStock("instock",info.p_pkval);
						else{
							that.Rollbacktaking(that.orderinfo.billid);
							this.$tool.loadingclose();
							this.$tool.message(res.message, 0);
							if(res.localfilename!=undefined){
								if(res.localfilename!=""){
									this.$tool.downfile(that,res.localfilename);
								}
							}
						}
					}
				}).catch(e=>{
					that.savein(paraminfo);
				});
			}else{
				that.saveout(paraminfo);
			}
		},
		//盘亏出库
		saveout(paraminfo){
			var that=this;
			var info=JSON.parse(JSON.stringify(paraminfo));
			var cargolist=JSON.parse(JSON.stringify(info.cargolist));
			
			var list=cargolist.filter(function(e){
				return parseInt(e.num)<parseInt(e.num2);//盘点数量小于账面数量
			});
			if(list.length>0){
				list.forEach(e=>{
					e.num=parseInt(e.num2)-parseInt(e.num);
				});
				info.p_pkval=new Date().getTime();
				info.p_bagid=info.orderinfo.storehouse;
				info.t_id="stock_out";
				info.p_sys="盘亏出库";
				info.p_mode="outstock";
				info.sendtype='';
				info.sendaddress='';
				info.cargolist=list;
				info.u_userid=localStorage.getItem('userid');
				//再生成盘亏单
				this.$apipost.post.SaveInfo({ paraminfo:info }).then(res => {
					if (res != '') {
						if(res.state=='1')
							that.UpdateStock("outstock",info.p_pkval);
						else{
							that.Rollbacktaking(that.orderinfo.billid);
							this.$tool.loadingclose();
							this.$tool.message(res.message, 0);
							if(res.localfilename!=undefined){
								if(res.localfilename!=""){
									this.$tool.downfile(that,res.localfilename);
								}
							}
						}
					}
				}).catch(e=>{
					that.saveout(paraminfo);
				});
			}else{
				this.$tool.loadingclose();
				that.showsuccesswin=true;
			}
		},
		//盘点记录回滚
		Rollbacktaking(billid){
			var that=this;
			var paraminfo={
				billid:billid
			}
			this.$apipost.post.Deltacking({ paraminfo:paraminfo }).then(res => {
				if (res != '') {
					if(res.state=='1'){
						
					}
				}
			}).catch(e=>{
				that.Rollbacktaking(billid);
			});
		},
		successfun(type){
			var that=this;
			if(type==1){
				this.orderinfo={
					billid:new Date().getTime(),
					storehouse:'',
					shelves:''
				}
				this.clearcargolist();
				this.showsuccesswin=false;
			}
			else{
				Utils.$emit('handleRermove', localStorage.getItem('tabname'));
			}
		},
		clearcargolist(){
			this.$refs.packagecargo.clearlist();
		},
		//更新库存
		UpdateStock(handletype,billid){
			var that=this;
			var paraminfo={
				billid:billid,
				storagehouse:this.orderinfo.storehouse,
				handletype:handletype,
				handleraccount: localStorage.getItem('u_account')
			}
			this.$apipost.post.UpdateStock({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					if(handletype=='outstock')
						that.showsuccesswin=true;
					else{
						var paraminfo=that.getorderObj();
						if(paraminfo!=''){
							that.saveout(paraminfo);
						}
					}	
				} else{
					that.$tool.message(res.message, 0);
				}
			}).catch(e=>{
				that.UpdateStock(handletype,billid);
			});
		},
		//远程搜索option 货架
		remoteMethod(query, col) {
			var that = this;
			if (query != '') {
				setTimeout(function() {
					if (col=='shelves') {
						that.GetShelves(query);
					}
				}, 100);
			}
		}
	}
}
</script>

<style>
</style>
